import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  link: {
    color: "blue",
    textDecoration: "underline"
  }
});

const SimpleLink = ({ children, className, ...props }) => {
  const classes = useStyles();
  return (
    <a {...props} className={clsx(classes.link, className)}>
      {children}
    </a>
  );
};

export default SimpleLink;
